import { createContext, use } from 'react';

const context = createContext(false);

export function IsGridProvider({ children }: { children: React.ReactNode }) {
	return <context.Provider value={true}>{children}</context.Provider>;
}

export default function useIsGrid(): boolean {
	return use(context);
}
